import { memo } from 'react';

function CompletedMarker({ backgroundColor, borderColor, size }) {

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M22.78 18V6L12.39 0L2 6V18L12.39 24L22.78 18Z" fill={backgroundColor} />
      <path
        d="M12.39 1.15L21.78 6.57V17.42L12.39 22.84L3 17.42V6.58L12.39 1.15ZM12.39 0L2 6V18L12.39 24L22.78 18V6L12.39 0Z"
        fill={borderColor}
      />
      <path
        d="M10.9799 17.2099L5.8999 12.1299L7.5699 10.4499L10.9799 13.8599L17.2099 7.62988L18.8899 9.29988L10.9799 17.2099Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(CompletedMarker);
